import React from 'react';
import { styled } from '@mui/material';
import { RText } from './RText';
import { Colors } from 'library';

type REmptyTextPadding = 'none' | 'sm' | 'md';

interface REmptyTextProps {
    children: React.ReactNode;
    padding?: 'none' | 'sm' | 'md';
    dashedBorder?: boolean;
}

const PADDING_VALUE: Record<REmptyTextPadding, string> = {
    none: '0px',
    sm: '24px 0px',
    md: '48px 0px',
};

export function REmptyText({ children, padding = 'md', dashedBorder = false }: REmptyTextProps) {
    const paddingValue = PADDING_VALUE[padding];
    return (
        <Wrapper padding={paddingValue} dashedBorder={dashedBorder}>
            <RText component="p" tone="secondary" align="center">
                {children}
            </RText>
        </Wrapper>
    );
}

const Wrapper = styled('div')<{ padding: string; dashedBorder: boolean }>(({ padding, dashedBorder }) => ({
    padding,
    ...(dashedBorder && {
        border: `1px dashed ${Colors.lightGrey}`,
        borderRadius: 10,
    }),
}));
